import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SurveyQuestionType } from '@shared/enums/SurveyQuestionType';

@Pipe({
  name: 'itemsForRatingChart'
})
export class ItemsForRatingChartPipe implements PipeTransform {

  constructor(private translation: TranslateService) {}

  // Use i18n currently loaded translation, since translations cannot be localized
  public currentLang = this.translation.currentLang;

  public transform(field: any, lang?: any): any {
    let options = [];
    if (lang) {
      this.currentLang = lang;
    }
    // eslint-disable-next-line guard-for-in
    for (const key in field.calculations) {
      options.push({
        value: field.calculations[key],
        name: key
      });
    }
    if (field.questionType === SurveyQuestionType.Score) {
        options = options.splice(1,5);
    }
    return options;
  }
}
